import React from "react";

const PendingApprovals = () => {
  return (
    <div className="dashboard-card">
      <div className="card-header">
        <h3 className="card-title">Pending Approvals</h3>
      </div>

      <div className="card-empty">
        No pending approvals.
      </div>
    </div>
  );
};

export default PendingApprovals;